import { PollTemplate } from "../create-poll/create-poll.type";

export class TemplateBank {
    templateListByTopics: TemplateListByTopic[];

    constructor(templateListByTopics: TemplateListByTopic[]) {
        this.templateListByTopics = templateListByTopics;
    }

    search(term: string): TemplateBank {
        const filteredTemplateListByTopics = this.templateListByTopics.map(templateList => {
            if(templateList.search(term) != null) {
                return templateList.search(term);
            }
        })
        return new TemplateBank(filteredTemplateListByTopics.filter(templateList => templateList != undefined));
    }
}

export class TemplateListByTopic {
    title: string;
    description: string;
    templates: PollTemplateForPreview[];

    constructor(title: string, description: string, templates: PollTemplateForPreview[]) {
        this.title = title;
        this.description = description;
        this.templates = templates;
    }

     search(term: string): TemplateListByTopic {
        const matchingTemplates = this.templates.filter(template => template.match(term))
        if (matchingTemplates.length > 0) {
            return new TemplateListByTopic(this.title, this.description, matchingTemplates);
        } else {
            return null;
        }
     }
}

export class PollTemplateForPreview extends PollTemplate {
    constructor(questionTemplate: PollTemplate) {
        super();
        this.id = questionTemplate.id;
        this.label = questionTemplate.label;
        this.answerOptions = questionTemplate.answerOptions;
    }

    match(term: string): boolean {
        return this.label.toLowerCase().includes(term.toLowerCase());
    }
}

export type PostNowAction = 'post' | 'customize';
